// src/components/AdminForm.js
import { useState } from "react";
import "./AdminForm.css";
import UserList from "./UserList";
import { useNavigate } from "react-router-dom";
import CreateUserForm from "./CreateUserForm";
import { apiFetch } from "../utils/api";
import AdminLayout from "../layouts/AdminLayout";


export default function AdminForm({ user, children }) {
  const navigate = useNavigate();
  const [article, setArticle] = useState({
	  title: "",
	  description: "",
	  category: "",
	  author: ""    // ✅ starts empty
	});

  const [imageFile, setImageFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [usersRefreshKey, setUsersRefreshKey] = useState(0);

  const refreshUsers = () => {
    setUsersRefreshKey(prev => prev + 1);
  };

  if (!user) return <p>Please log in to submit articles.</p>;

  const handleChange = (e) => {
    setArticle({ ...article, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("title", article.title);
      formData.append("description", article.description);
      formData.append("category", article.category);
      formData.append("author", article.author);
      if (imageFile) formData.append("image", imageFile);

      const res = await apiFetch("/articles/upload", {
        method: "POST",
        body: formData
      });

      if (!res.ok) {
        throw new Error("Upload failed");
      }

      alert("Article submitted successfully!");

      setArticle({
        title: "",
        description: "",
        category: "",
        author: ""
      });
      setImageFile(null);

      if (window.opener && !window.opener.closed) {
        window.opener.location.reload();
      }
    } catch (err) {
      console.error("Error submitting article:", err);
      alert("Failed to submit article. Check console for details.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-form-container">
      {children ? (
        children
      ) : (
        <>
          <h3>Submit a New Article</h3>

          <form onSubmit={handleSubmit}>
            <input
              name="title"
              placeholder="Title"
              value={article.title}
              onChange={handleChange}
              required
            />

            <input
              name="author"
              placeholder="Author name (optional)"
              value={article.author}
              onChange={handleChange}
            />

            <input
              name="category"
              placeholder="Category"
              value={article.category}
              onChange={handleChange}
              required
            />

            <input type="file" onChange={handleFileChange} accept="image/*" />

            <textarea
              name="description"
              placeholder="Description"
              value={article.description}
              onChange={handleChange}
              required
            />

            <button type="submit" disabled={submitting}>
              {submitting ? "Submitting..." : "Submit Article"}
            </button>
            <button
              type="button"
              onClick={() => navigate("/admin/change-password")}
              className="admin-secondary-btn"
            >
              Change My Password
            </button>
            <button
              type="button"
              onClick={() => navigate("/admin/pending")}
              className="admin-secondary-btn"
            >
              Pending Articles
            </button>
          </form>
          {user?.role === "superadmin" && (
            <>
              <UserList
                user={user}
                refreshKey={usersRefreshKey}
                onUserChanged={refreshUsers}
              />
              <CreateUserForm
                user={user}
                onUserCreated={refreshUsers}
              />
            </>
          )}
        </>
      )}
    </div>
);

}
